module.exports = __webpack_public_path__ + "media/src/img/help-vector-caf0b30b13d8437531a82996d77d6509.svg";